import { render, staticRenderFns } from "./GruButton.vue?vue&type=template&id=3c3f34f3&scoped=true"
import script from "./GruButton.vue?vue&type=script&lang=js"
export * from "./GruButton.vue?vue&type=script&lang=js"
import style0 from "./GruButton.vue?vue&type=style&index=0&id=3c3f34f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3f34f3",
  null
  
)

export default component.exports